import { useEffect } from "react";

import { useParams } from "react-router-dom";
import TemplateContainer from "../components/TemplateContainer";
import { DeviceProvider } from "../utils/DeviceProvider";
import { ResetContextMenuProvider } from "../utils/ResetContextMenuProvider";

export const DevicesPage = () => {
  const { unitid } = useParams<{ unitid: string }>();

  useEffect(() => {
    document.title = `${unitid} - MOHAnet Toolbox`;
  }, [unitid]);

  return (
    <DeviceProvider unitid={parseInt(unitid)}>
      <ResetContextMenuProvider>
        <TemplateContainer />
      </ResetContextMenuProvider>
    </DeviceProvider>
  );
};

export default DevicesPage;
